__turbopack_context__.v({
  "className": "inter_5a7536b1-module__cG1yvW__className",
  "variable": "inter_5a7536b1-module__cG1yvW__variable",
});
